import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
let _pending = null;

async function loadFlags() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = api.get("/flags").then(({ data }) => {
    _cache = data || {};
    _pending = null;
    return _cache;
  }).catch(() => {
    _pending = null;
    return {};
  });
  return _pending;
}

/**
 * useFeatureFlag("gst_module") → boolean (defaults to `false` while loading).
 * Cache lives for the lifetime of the tab; refresh on login/logout.
 */
export function useFeatureFlag(key, defaultValue = false) {
  const [enabled, setEnabled] = useState(defaultValue);
  useEffect(() => {
    let mounted = true;
    loadFlags().then((f) => { if (mounted) setEnabled(!!f[key]); });
    return () => { mounted = false; };
  }, [key]);
  return enabled;
}

export function resetFeatureFlagCache() {
  _cache = null;
  _pending = null;
}

export default useFeatureFlag;
